// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function comment_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var comment = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
  if (comment.TAG === /* Ok */0) {
    var admin_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "admin_name"), null));
    if (admin_name.TAG === /* Ok */0) {
      var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
      if (timestamp.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  comment: comment._0,
                  admin_name: admin_name._0,
                  timestamp: timestamp._0
                }
              };
      }
      var e = timestamp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".timestamp" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = admin_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".admin_name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = comment._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".comment" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var comments = Decco.listFromJson(comment_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "comments"), null));
  if (comments.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              comments: comments._0
            }
          };
  }
  var e = comments._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".comments" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  comment_info_decode ,
  t_decode ,
  
}
/* No side effect */
